import { Input, TimePicker, Button, Switch } from "@ds/ds-snam/react";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { TIME_FORMAT,DATE_FORMAT, DsLayout, AppUserRole, IAppUserProfile, ResponseStatus, ResponseCode, SnamPlantKey } from "shared/constants";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { useDispatch, useSelector } from "react-redux";
import { getParametersSlot, putParametersSlot } from "net/settings";
import { IParametersSlot } from "dataModels/settings";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { appStore, RootState } from "state/appStore";
import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";

const defaultFormData : IParametersSlot = {
    slotDuration: '00:00',
    slotOverlapping: '00:00',
    loading:0,
    coolDown:0,
    gasUp:0,
    semiTrailerApproval:0,
    driverApproval:0,
    semiTrailerAndDriverApproval:0,
    isoContainerApproval:0,
    isoContainerAndDriverApproval:0,
    loadingAvailablePlant:false,
    coolDownAvailablePlant:false,
    gasUpAvailablePlant:false,
    semiTrailerApprovalAvailablePlant:false,
    driverApprovalAvailablePlant:false,
    semiTrailerAndDriverApprovalAvailablePlant:false,
    isoContainerApprovalAvailablePlant:false,
    isoContainerAndDriverApprovalAvailablePlant:false,
    percentageFuelGas:10,
    dailyGasPrice:0
}

const SlotParametersView:React.FC<{}> = ():JSX.Element=>{
    const [formData,setFormData] = useState<IParametersSlot>(defaultFormData);
    const { t } = useTranslation(['contract', 'app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const dispatch = useDispatch();
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    const plantIdValue: string|undefined = appStore.getState().plant.plantId;
    

    const loadData = useCallback(() => {
        dispatch(requestPending());
        getParametersSlot() //Todo: questo indica il sito, che adesso è solamente 1, in futuro potranno essercene altri
            .then((data: IParametersSlot) => {
                /*let mock:IParametersSlot = {
                    "plantId": "2",
                    "slotDuration": "04:00",
                    "slotOverlapping": "02:00",
                    "loading": 1,
                    "loadingAvailablePlant": true,
                    "coolDown": 2,
                    "coolDownAvailablePlant": true,
                    "gasUp": 2,
                    "gasUpAvailablePlant": true,
                    "semiTrailerApproval": 2,
                    "semiTrailerApprovalAvailablePlant": true,
                    "driverApproval": 2,
                    "driverApprovalAvailablePlant": true,
                    "semiTrailerAndDriverApproval": 2,
                    "semiTrailerAndDriverApprovalAvailablePlant": true,
                    "isoContainerApproval": 2,
                    "isoContainerApprovalAvailablePlant": true,
                    "isoContainerAndDriverApproval": 2,
                    "isoContainerAndDriverApprovalAvailablePlant": true,
                    "percentageFuelGas":10,
                    "dailyGasPrice": 100
                }
                setFormData(mock);*/
                setFormData(data);
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })
    }, [dispatch]);
    
    useEffect(() => {
        loadData()
    }, [loadData]);

    
    const onTextInputChange = (inputEvent: Event) => {
        //console.log(Number((inputEvent as CustomEvent).detail.input.value))
        const fieldName = (inputEvent as CustomEvent).detail.input.name;
        let currentData: IParametersSlot = formData;
        let value = Number((inputEvent as CustomEvent).detail.input.value);
        (currentData[fieldName as keyof IParametersSlot] as number) = value;
        setFormData(currentData);
    }

    const putData = (currentFormData:IParametersSlot) => {
        //console.log(currentFormData)
        let popUpAction: INotificationAction;
        dispatch(requestPending());
        putParametersSlot(currentFormData)
            .then(response => {
                const popUpTitle: string = response.data.status === ResponseStatus.ERROR ? 'Error' : (response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? 'Attention' : t('settings.slotParameters.snackTitle'));
                const popUpDescription: string = response.data.status === ResponseStatus.ERROR || response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? response.data.message : t('settings.slotParameters.snackText');
                const popUpStatus: NotificationsStatusType = response.data.status === ResponseStatus.ERROR ? "error" : (response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? "warning" : "confirm");
                
                popUpAction = {
                    show: true,
                    title: popUpTitle,// "Parametri impostati correttamente",
                    description: popUpDescription,//"I parametri sono stati impostati correttamente e verranno visualizzati sul calendario",
                    status:popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                //navigate();
            }).catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            });
    }

    const onTimeInputChange = (inputEvent: Event,fieldName:string) => {
        //console.log((inputEvent as CustomEvent).detail.time)
        let currentData: IParametersSlot = formData;
        (currentData[fieldName as keyof IParametersSlot] as string)=(inputEvent as CustomEvent).detail.time;
        setFormData(currentData);
    }

    const getInputCol = (inputTitle:string,inputValue:string,inputName:string,inputId:string) => {
        const availabilityMap: Record<string, keyof IParametersSlot> = {
            loading: "loadingAvailablePlant",
            coolDown: "coolDownAvailablePlant",
            gasUp: "gasUpAvailablePlant",
            driverApproval:"driverApprovalAvailablePlant",
            semiTrailerAndDriverApproval:"semiTrailerAndDriverApprovalAvailablePlant",
            semiTrailerApproval: "semiTrailerApprovalAvailablePlant",
            isoContainerApproval: "isoContainerApprovalAvailablePlant",
            isoContainerAndDriverApproval: "isoContainerAndDriverApprovalAvailablePlant",
        };
        const isDisabled = appUserRole === AppUserRole.READER || !formData[availabilityMap[inputName]];
        return(
            <>
                <Input
                    inputLabel={inputTitle} 
                    inputValue={inputValue}
                    inputName={inputName}
                    inputId={inputId}
                    isNumberVariant={true}
                    isDisabled={isDisabled}
                    onInputChange={onTextInputChange}
                    maxDecimalDigits={0}
                ></Input>
            </>
        );
    }

    const onSwitchInputChange = (label: string, switchLabel: string) => {
        setFormData(prevState => ({
            ...prevState,
            [label]: switchLabel === "right"
        }));
    };

    const getInputSwitch = (label: keyof IParametersSlot) =>{
        return <Switch
            switchLabelLeft={t('settings.slotParameters.btnLeft')}
            switchLabelRight={t('settings.slotParameters.btnRight')}
            //switchIconLeft="icon-add-circle"
            //switchIconRight="icon-add-circle"
            switchSize="medium"
            checkedButton={formData[label] ? "right" : "left"}
            buttonLeftAriaLabel="Left aria text"
            buttonRightAriaLabel="Right aria text"
            switchLeftId="switchLeftId"
            switchRightId="switchRightId"
            onSwitchChange={(event:Event) => {
                //console.log((event as CustomEvent).detail);
                //console.log(label);
                onSwitchInputChange(label,(event as CustomEvent).detail.switch);
            }}
            style={{float:'right'}}
        ></Switch>
    }
    
    return(
        <>
        <p className="pageTitle">
            {t('settings.slotParameters.title')} {/*Parametri slot*/}
        </p>
        <p className="pageSubTitle">
            {t('settings.slotParameters.sub_title.0')}{/*Imposta i parametri degli slot da rendere visibili sul calendario*/}
        </p>
        <p className="pageSubTitle">
            {t('settings.slotParameters.sub_title.3')}
        </p>
        <div className="listTableContainerGrey">
            {/*<Row>
                <Col>
                    <p className="formSubTitle">
                    {t('settings.slotParameters.sub_title.1')}
                    </p>
                </Col>
            </Row>*/}
            
            <Row>
                
                <Col xs={12} md={5}> 
                    <div className="textInputWrapper">
                        <TimePicker
                            startTime="00:00"
                            endTime="23:59"
                            timeInterval={5}
                            timePickerTitle={t('settings.slotFreezing.label1')}
                            timePickerPlaceholder={t('settings.slotFreezing.timeSelect')} //"Seleziona orario"
                            isDisabled={appUserRole===AppUserRole.READER}
                            timePickerStatus="default"
                            hasCloseButton={false}
                            isReadonly={false}
                            defaultTime={formData.slotDuration}
                            isPanelTop={false}
                            onTimeSelection={(event: Event) => {
                                onTimeInputChange(event,'slotDuration')
                            }}
                        />
                        {/*<TimePicker
                            timepickerId="timePickerId"
                            startTime="00:00"
                            endTime="23:59"
                            timeInterval={5}
                            timePickerTitle={t('settings.slotFreezing.label1')}
                            timePickerPlaceholder={t('settings.slotFreezing.timeSelect')} //"Seleziona orario"
                            isDisabled={appUserRole===AppUserRole.READER}
                            timePickerStatus="default"
                            leftButtonLabel="Annulla"
                            rightButtonLabel="Conferma"
                            backButtonAriaLabel="torna indietro"
                            hasCloseButton={false}
                            isReadonly={false}
                            defaultTime={formData.slotDuration}
                            description="Description"
                            isPanelTop={false}
                            onTimeSelection={(event: Event) => {
                                onTimeInputChange(event,'slotDuration')
                            }}
                            onLeftButtonClick={()=>{console.log('left button clicked')}}
                            onCloseButtonClick={()=>{console.log('close button clicked')}}
                            hasTooltip={true}
                            tooltipPosition="top"
                            tooltipText="Tooltip"
                            isLoading={false}
                            loadingType="total"
                            hasCurrentTimeSelected={true}
                            zIndex={999}
                            ></TimePicker>*/}
                    </div>
                </Col>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper">
                        <TimePicker
                            startTime="00:00"
                            endTime="23:59"
                            timeInterval={5}
                            timePickerTitle={t('settings.slotFreezing.label2')}
                            timePickerPlaceholder={t('settings.slotFreezing.timeSelect')} //"Seleziona orario"
                            isDisabled={appUserRole===AppUserRole.READER}
                            timePickerStatus="default"
                            hasCloseButton={false}
                            isReadonly={false}
                            defaultTime={formData.slotOverlapping}
                            isPanelTop={false}
                            onTimeSelection={(event: Event) => {
                                onTimeInputChange(event,'slotOverlapping')
                            }}
                        />
                    </div>
                </Col>
            </Row>

            
            {plantIdValue===SnamPlantKey.PIGNATARO &&
            <>
            
            <Row style={{marginTop:'12px'}}>
                <Col>
                    <p className="formSubTitle">
                    {t('settings.slotParameters.titleGas')}
                    </p>
                </Col>
            </Row>
            <div style={{marginBottom:'20px'}}>
                <Row>
                    <Col xs={12} md={5}>
                        <Input
                            inputLabel={t('settings.slotParameters.percentageFuelGasPignataro')}
                            inputValue={formData.percentageFuelGas!==null?formData.percentageFuelGas.toString():""}
                            inputName={"percentageFuelGas"}
                            inputId={"percentageFuelGas"}
                            isNumberVariant={true}
                            maxValue={100}
                            minValue={0}
                            isDisabled={false}
                            onInputChange={onTextInputChange}
                            maxDecimalDigits={0}
                        ></Input>
                    </Col>
                    <Col xs={12} md={5}>
                        <Input
                            inputLabel={t('settings.slotParameters.dailyGasPricePignataro')}
                            inputValue={formData.dailyGasPrice!==null?formData.dailyGasPrice.toString():""}
                            inputName={"dailyGasPrice"}
                            inputDescription={t('settings.slotParameters.dailyGasPricePignataroSubtitle')}
                            inputId={"dailyGasPrice"}
                            isNumberVariant={true}
                            isDisabled={false}
                            onInputChange={onTextInputChange}
                            maxDecimalDigits={3}
                        ></Input>
                    </Col>
                </Row>
            </div>
            </>}

            <Row style={{marginTop:'12px'}}>
                <Col>
                    <p className="formSubTitle">
                    {t('settings.slotParameters.sub_title.2')}{/*Inserisci il numero di slot necessari per ogni servizio*/}
                    </p>
                </Col>
            </Row>
            <Row style={{marginTop:'12px'}}>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper"  style={{display:'flex'}}>
                        <div style={{flex:'1'}}>{getInputCol("Truck Loading*",formData.loading.toString(),"loading","input-id-loading")}</div>
                        <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch("loadingAvailablePlant")}</div>
                    </div>
                </Col>
            </Row>
            <Row style={{marginTop:'12px'}}>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper" style={{display:'flex'}}>
                        <div style={{flex:'1'}}>{getInputCol("Cool Down + Truck Loading*",formData.coolDown.toString(),"coolDown","input-id-coolDown")}</div>
                        <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch("coolDownAvailablePlant")}</div>
                    </div>
                </Col>
            </Row>
            <Row style={{marginTop:'12px'}}>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper" style={{display:'flex'}}>
                        <div style={{flex:'1'}}>{getInputCol("Gas Up + Cool Down*",formData.gasUp.toString(),"gasUp","input-id-gasUp")}</div>
                        <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch("gasUpAvailablePlant")}</div>
                    </div>
                </Col>
                
            </Row>
            <Row style={{marginTop:'12px'}}>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper" style={{display:'flex'}}>
                        <div style={{flex:'1'}}>{getInputCol("Semi-trailer Approval + Truck Loading*",formData.semiTrailerApproval.toString(),"semiTrailerApproval","input-id-semiTrailerApproval")}</div>
                        <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch("semiTrailerApprovalAvailablePlant")}</div>
                    </div>
                </Col>
            </Row>
            <Row style={{marginTop:'12px'}}>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper" style={{display:'flex'}}>
                        <div style={{flex:'1'}}>{getInputCol("Driver Approval + Truck Loading*",formData.driverApproval.toString(),"driverApproval","input-id-driverApproval")}</div>
                        <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch("driverApprovalAvailablePlant")}</div>
                    </div>
                </Col>
                
            </Row>
            <Row style={{marginTop:'12px'}}>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper" style={{display:'flex'}}>
                        <div style={{flex:'1'}}>{getInputCol("Semi-trailer + Driver Approval + Truck Loading*",formData.semiTrailerAndDriverApproval.toString(),"semiTrailerAndDriverApproval","input-id-semiTrailerAndDriverApproval")}</div>
                        <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch("semiTrailerAndDriverApprovalAvailablePlant")}</div>
                    </div>
                </Col>
            </Row>
            <Row style={{marginTop:'12px'}}>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper" style={{display:'flex'}}>
                        <div style={{flex:'1'}}>{getInputCol("ISO Container Approval + Truck Loading*",formData.isoContainerApproval.toString(),"isoContainerApproval","input-id-isoContainerApproval")}</div>
                        <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch("isoContainerApprovalAvailablePlant")}</div>
                    </div>
                </Col>
                
            </Row>
            <Row style={{marginTop:'12px'}}>
                <Col xs={12} md={5}>
                    <div className="textInputWrapper" style={{display:'flex'}}>
                        <div style={{flex:'1'}}>{getInputCol("ISO Container Approval + Driver Approval + Truck Loading*",formData.isoContainerAndDriverApproval.toString(),"isoContainerAndDriverApproval","input-id-isoContainerAndDriverApproval")}</div>
                        <div style={{width:'195px',marginTop:'20px'}}>{getInputSwitch("isoContainerAndDriverApprovalAvailablePlant")}</div>
                    </div>
                </Col>
            </Row>
        </div>
        <div style={{float:'right',paddingTop:'20px',paddingBottom:'20px'}}>
            <Button
                buttonType="button"
                buttonUIVariant="primary"
                buttonSize="medium"
                buttonLabel={t('general.buttons.config', { ns: 'app' })}
                buttonIcon=""
                isDisabled={appUserRole===AppUserRole.READER}
                onClickEvent={(event: Event) => {
                    //let currentFormData = {...formData}
                    //currentFormData.slotDuration = new Date(formData.slotDuration).getTime()/1000;
                    //currentFormData.slotOverlapping = new Date(formData.slotOverlapping).getTime()/1000;
                    //console.log(formData)
                   // setFormData(currentFormData);
                    putData(formData);
                }}
            />
        </div>
    </>


    );
}
export default SlotParametersView;

